
// 引入vant的弹出框
import { Dialog } from 'vant'

// 请求异常提示,检测请求没有网络和超时的情况
function errorModal(error, codeNumber = '') {
    console.log(error);
    let errMsg;
    if( typeof(error) === 'string' ){
      errMsg = error;
    }else{
      errMsg = error.message;
    }
    let codeText = codeNumber ? ' (' + codeNumber + ')' : '';
    // 判断是否是网络异常(借口异常也可能报错502(Bad Gateway))
    if (errMsg.includes('Network')) {
      // console.log('网络错误，请检查网络');
      Dialog({
        message: '网络异常，请检查网络' + codeText
      })
    }
    // 判断请求异常信息中是否含有超时timeout字符串
    if(errMsg.includes('timeout')){
      // console.log('请求超时，请稍后再试');
      Dialog({
        message: '请求超时，请稍后再试' + codeText
      })
    }
    // 其他情况
    if(!(errMsg.includes('Network') || errMsg.includes('timeout'))){
      // console.log('错误');
      Dialog({
        message: '请求错误' + codeText
      })
    }
}

export {
  errorModal
};
